import { DatePipe } from '@angular/common';
import { Component, Input } from '@angular/core';
import { StatusField } from '@ukam/core/models/status-field';

@Component({
  selector: 'app-status-badge-sm',
  standalone: true,
  templateUrl: './status-badge-sm.component.html',
  imports: [DatePipe],
  host: { style: 'display: contents' },
})
export class AppStatusBadgeSmComponent {
  @Input() status?: StatusField | null;
}
